<template>
  <icon-lucide-ellipsis />
</template>
